import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  DashboardOutlined,
  UserAddOutlined,
  ProductOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
  BorderOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu, theme, Avatar, Dropdown } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();

  const handleMenuClick = (e) => {
    if (e.key === 'signout') {
      // Handle logout logic here
    } else {
      navigate(e.key);
    }
  };

  const userMenu = (
    <Menu>
      {/* <Menu.Item key="profile" icon={<UserOutlined />}>
        Profile
      </Menu.Item>
      <Menu.Item key="signout" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item> */}
    </Menu>
  );

  return (
    <Layout style={{ minHeight: '100vh', fontFamily: 'Poppins, sans-serif' }}>
      <Sider trigger={null} collapsible collapsed={collapsed} style={{ backgroundColor: 'teal' }}>
        <div className="demo-logo-vertical" />
        <h1 className="d-none d-md-block" style={{ color: 'Whitesmoke', margin: '16px', fontSize: '20px' }}>
          ACCI
        </h1>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['']}
          onClick={handleMenuClick}
          style={{ backgroundColor: 'teal' }}
        >
          <Menu.Item key="" style={{ backgroundColor: 'teal' }} icon={<DashboardOutlined className="fs-4" />}>
            Dashboard
          </Menu.Item>
          <Menu.SubMenu key="Users" icon={<UserOutlined className="fs-4" />} title="MEMBERS">
            <Menu.Item
              key="otherparticipations"
              style={{ backgroundColor: 'teal' }}
              icon={<UserOutlined className="fs-4" />}
            >
              MEMBER
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Santha" icon={<OrderedListOutlined className="fs-4" />} title="Santha">
            <Menu.Item
              key="santhamaster"
              style={{ backgroundColor: 'teal' }}
              icon={<BorderOutlined className="fs-4" />}
            >
              Sandha Master
            </Menu.Item>
            <Menu.Item key="santha" style={{ backgroundColor: 'teal' }} icon={<BorderOutlined className="fs-4" />}>
              Sandha Form
            </Menu.Item>
            <Menu.Item key="santhalive" style={{ backgroundColor: 'teal' }} icon={<BorderOutlined className="fs-4" />}>
              Sandha Live Form
            </Menu.Item>
            <Menu.Item key="donation" style={{ backgroundColor: 'teal' }} icon={<BorderOutlined className="fs-4" />}>
              Sandha Donation Form
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Events" icon={<ProductOutlined className="fs-4" />} title="Events">
            <Menu.Item key="event" style={{ backgroundColor: 'teal' }} icon={<BorderOutlined className="fs-4" />}>
              Event Registration
            </Menu.Item>
            <Menu.Item
              key="transactions"
              style={{ backgroundColor: 'teal' }}
              icon={<BorderOutlined className="fs-4" />}
            >
              Transactions
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Expense" icon={<OrderedListOutlined className="fs-4" />} title="Expense">
            <Menu.Item
              key="expense-master"
              style={{ backgroundColor: 'teal' }}
              icon={<BorderOutlined className="fs-4" />}
            >
              Expense Master
            </Menu.Item>
         
            <Menu.Item
              key="expense-form"
              style={{ backgroundColor: 'teal' }}
              icon={<BorderOutlined className="fs-4" />}
            >
              Expense Form
            </Menu.Item>
          </Menu.SubMenu>
          
          <Menu.SubMenu key="Attendance" icon={<OrderedListOutlined className="fs-4" />} title="Attendance List">
          <Menu.Item key="pre-con" style={{ backgroundColor: 'teal' }} icon={<LogoutOutlined className="fs-4" />}>
            Pre-Conformation
          </Menu.Item> 
          <Menu.Item key="attendance" style={{ backgroundColor: 'teal' }} icon={<LogoutOutlined className="fs-4" />}>
            Attendance
          </Menu.Item>
          </Menu.SubMenu>
          <Menu.Item key="/" icon={<LogoutOutlined className="fs-4" />}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            padding: 0,
            background: colorBgContainer,
            fontFamily: 'Poppins, sans-serif',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 16px',
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <Dropdown overlay={userMenu} trigger={['click']}>
            <Avatar style={{ cursor: 'pointer' }} icon={<UserOutlined />} size="Medium" />
          </Dropdown>
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;